function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_26",
  "data-name": "Layer 26"
}, /*#__PURE__*/React.createElement("path", {
  d: "m46 2a15.979 15.979 0 0 0 -12.909 25.425l-2.091 5.575 5.575-2.091a15.993 15.993 0 1 0 9.425-28.909z",
  fill: "#bce4f8"
}), /*#__PURE__*/React.createElement("path", {
  d: "m46 2a15.963 15.963 0 0 0 -13.2 25h17.2a7 7 0 0 0 7-7v-13.6a15.929 15.929 0 0 0 -11-4.4z",
  fill: "#e4f5fd"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#fff",
  height: 12,
  rx: 2,
  width: 15,
  x: 37,
  y: 9
}), /*#__PURE__*/React.createElement("path", {
  d: "m52.9 18.136c2.918-4.6-.229-10.628-6.086-11.1-.272-.025-.541-.036-.814-.036s-.542.011-.809.033c-5.857.475-9 6.506-6.086 11.1l6.895 10.867z",
  fill: "#aa2b24"
}), /*#__PURE__*/React.createElement("path", {
  d: "m51 17v-8.409a8.053 8.053 0 0 0 -4.191-1.558c-.267-.022-.536-.033-.809-.033s-.542.011-.809.033c-5.857.475-9 6.506-6.086 11.1l1.818 2.867h6.077a4 4 0 0 0 4-4z",
  fill: "#d24034"
}), /*#__PURE__*/React.createElement("path", {
  d: "m37.061 41.939 3.939-3.939 13 13-8.879 8.879a7.242 7.242 0 0 1 -5.121 2.121 7.242 7.242 0 0 1 -5.121-2.121l-30.758-30.758a7.242 7.242 0 0 1 -2.121-5.121 7.242 7.242 0 0 1 2.121-5.121l8.879-8.879 13 13-3.939 3.939a3.624 3.624 0 0 0 -1.061 2.561 3.624 3.624 0 0 0 1.061 2.561l9.878 9.878a3.624 3.624 0 0 0 2.561 1.061 3.624 3.624 0 0 0 2.561-1.061z",
  fill: "#559b38"
}), /*#__PURE__*/React.createElement("path", {
  d: "m43.879 36.808h4.243v18.385h-4.243z",
  fill: "#6bc148",
  transform: "matrix(.707 -.707 .707 .707 -19.054 46)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m15.879 8.808h4.243v18.385h-4.243z",
  fill: "#6bc148",
  transform: "matrix(.707 -.707 .707 .707 -7.456 18)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 15,
  fill: "#fff",
  r: 3
}));

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone.3818f644.svg";
export { ForwardRef as ReactComponent };